var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEn = function SvgEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "en_svg__a",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "en_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#en_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#en_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m0 0 .516 1.418L0 2.9v1.483l2.063 3.48L0 11.343v2.063L2.063 16.5 0 19.594v2.062l2.063 3.48L0 28.618V33l1.418-.516L2.9 33h1.483l3.48-2.062L11.343 33h2.063l3.094-2.062L19.594 33h2.062l3.48-2.062L28.618 33H33l-.516-1.418L33 30.1v-1.483l-2.062-3.48L33 21.657v-2.063L30.938 16.5 33 13.406v-2.062l-2.062-3.48L33 4.382V0l-1.418.516L30.1 0h-1.483l-3.48 2.063L21.657 0h-2.063L16.5 2.063 13.406 0h-2.062l-3.48 2.063L4.382 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M21.656 0v6.96L28.617 0zM33 4.383l-6.96 6.96H33zm-33 6.96h6.96L0 4.384zM4.383 0l6.96 6.96V0zm6.96 33v-6.96L4.384 33zM0 28.617l6.96-6.96H0zm33-6.96h-6.96l6.96 6.96zM28.617 33l-6.96-6.96V33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 0v2.9l8.443 8.444h2.9zm13.406 0v13.406H0v6.188h13.406V33h6.188V19.594H33v-6.188H19.594V0zM30.1 0l-8.444 8.443v2.9L33 0zM11.344 21.656 0 33h2.9l8.444-8.443zm10.312 0L33 33v-2.9l-8.443-8.444z"
  })))));
};
export default SvgEn;